import { gql } from '@apollo/client'

const facilityFragment = `
  id
  name
  city
  state
  timezone
`

export const GET_PAYMENT_REQUEST_ENROLLMENT = gql`
  query GetEnrollmentForPayment($paymentRequestToken: ID!) {
    paymentRequest(paymentRequestToken: $paymentRequestToken) {
      id
      paymentRequestedDate
      paymentRequestToken
      canceledEnrollment: isCanceled
      isPaid
      confirmationCode
      student {
        id
        firstName
        lastName
        contact {
          firstName
          lastName
          email
        }
      }
      lesson {
        coach {
          id
          name
          coachProfile {
            id
            slug
            profilePhoto
            title
          }
        }
        coachFacility {
          ${facilityFragment}
        }
        id
        title
        description
        canceledLesson: isCanceled
        startDateTime
        endDateTime
        timezone
        ... on Session {
          lessonType {
            title
            description
            id
            category
            priceInCents
            acceptsOnlinePayments
            durationInMinutes
            facilities {
              ${facilityFragment}
            }
          }
        }
        ... on GroupEvent {
          slug
          tags
          featuredImageUrl
          priceInCents
          totalPriceInCents
          acceptsOnlinePayments
          paymentRecurrenceSchedule
          numberOfPayments
          lessonCount
          registrationCloseDateTime
          externalRegistrationUrl
          registrationCount
          sessions {
            id
            startDateTime
            endDateTime
          }
        }
      }
    }
  }
`
